module.exports = __webpack_public_path__ + "static/media/answer-paper.609ff5d0.png";